import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18next from './i18n';
import Route from './Routes';
import './assets/scss/themes.scss';

function App() {
    return (
        <I18nextProvider i18n={i18next}>
            <React.Fragment>
                <Route />
            </React.Fragment>
        </I18nextProvider>
    );
}

export default App;